module.exports = __webpack_public_path__ + "img/type-email.d4234d3c.svg";